<template>
    <el-dialog
        title="添加面授"
        :visible.sync="visible"
        width="7.7rem"
        class="step-audit-dialog"
        key="face"
        :before-close="handleFaceDialogClose">
        <el-form :model="form" :rules="rules" ref="faceDialogForm" label-width="200px" key="2" class="user-step-dialog-form">
            <el-form-item label="面授名称：" prop="activityName">
                <el-input v-model="form.activityName" placeholder="请输入面授名称"></el-input>
            </el-form-item>
            <el-form-item label="面授起止时间：" prop="timeRange">
                <el-date-picker
                    v-model="form.timeRange"
                    type="daterange"
                        placeholder="请选择面授起止时间"
                    range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="面授教室：" prop="classroom" placeholder="请输入面授教室">
                <el-input v-model="form.classroom"></el-input>
            </el-form-item>
            <el-form-item label="面授讲师：" prop="lectorId">
                <el-select v-model="form.lectorId" placeholder="请选择面授讲师">
                    <el-option 
                        v-for="(item, index) in lectorList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="面授说明：" prop="instructions">
                <el-input v-model="form.instructions"></el-input>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleFaceDialogSave('faceDialogForm')">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'face-dialog',
    props: ['visible'],
    data() {
        return {
            lectorList: [],
            form: {
                activityName: '',
                classroom: '',
                lectorId: '',
                instructions: '',
                startTime: '',
                endTime: '',
                timeRange: []
            },
            rules: {
                activityName: [
                    { required: true, message: '请输入面授名称', trigger: 'change' },
                ],
                timeRange: [
                    { required: true, message: '请输入面授起止时间段', trigger: 'change' },
                ],
                classroom: [
                    { required: true, message: '请输入面授教室', trigger: 'change' },
                ],
                lectorId: [
                    { required: true, message: '请选择面授讲师', trigger: 'change' },
                ]
            }
        }
    },
    methods: {
        // 弹窗-面授保存
        handleFaceDialogSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('confirmDailog', this.form)
                    this.handleFaceDialogClose()
                } else {
                    return false;
                }
            });
        },
        // 弹窗-面授关闭
        handleFaceDialogClose() {
            this.$emit('closeDailog')
        },
        // 讲师
        courseLectorList() {
            this.$api.user.baseInfo.courseLectorList({
                formData: {},
                pageData: {currentPage: 1, pageSize: 99999}
            }).then(res => {
                this.lectorList = res.data.list
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.courseLectorList()
                this.$nextTick(() => {
                    this.$refs.faceDialogForm.resetFields()
                })
            }
        }
    }
}
</script>